<template>
  <div class="guide-breadcrumb-bar">
    <div class="guide-breadcrumb-bar__inner">
      <nav class="guide-breadcrumb" aria-label="Breadcrumb">
        <ol class="guide-breadcrumb__list">
          <li
            v-for="(item, index) in items"
            :key="index"
            class="guide-breadcrumb__item"
            :class="{ 'guide-breadcrumb__item--current': index === items.length - 1 }"
          >
            <a v-if="item.href" :href="item.href">{{ item.label }}</a>
            <span v-else aria-current="page">{{ item.label }}</span>
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>

<script>
/** 引导页面包屑：最后一项无 href 时为当前页 */
export default {
  name: 'GuideBreadcrumb',
  props: {
    items: {
      type: Array,
      required: true,
      // { label: string, href?: string }
    },
  },
}
</script>
